<template>
  <div class="input-staff">
    <el-input :placeholder="`请${title}`" v-model="name" disabled>
      <el-button slot="append" @click="visible = true">选择</el-button>
    </el-input>
    <el-dialog :title="title" :visible.sync="visible" width="50%">
      <role-user :isMultiple="isMultiple" @selectionChange="selectChange"></role-user>
      <span slot="footer" class="dialog-footer" v-if="isMultiple">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmSelect">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RoleUser from "@/components/role-user";
export default {
  name: "select-user",
  props: {
    title: { default: "选择人员" },
    name: String,
    isMultiple: { default: false },
  },
  data() {
    return {
      visible: false,
      staffs: [],
    };
  },
  methods: {
    selectChange(users) {
      if (this.isMultiple) {
        this.staffs = users;
      } else {
        this.visible = false;
        this.$emit("confirmSelect", users);
      }
    },
    confirmSelect() {
      this.visible = false;
      this.$emit("confirmSelect", this.staffs);
    },
  },
  components: { RoleUser },
};
</script>
<style scoped lang="scss">
::v-deep{
  .el-input__inner{
    border-color: #DCDFE6 !important;
  }
}
</style>
